// Detects local/dev environments by HOSTNAME only.
//
// The old check was `/localhost|dev/i.test(window.location.href)`, which tested
// the ENTIRE url (path + query + hash). That means any production url that
// merely contained the letters "dev" anywhere — e.g. a product slug like
// `/store/product/devotional-book` or `?ref=dev` — would silently unlock
// dev-only behavior (including the bsm.* permission bypass). This anchors the
// check to the hostname and only treats a leading `dev` subdomain label as dev.
//
// Dev is served from localhost or a `dev`-prefixed subdomain, e.g.
// dev-store.wwg.support, dev-ca-store.wwg.support, dev-bsm.wwg.support.
// Production hosts (store.wwg.support, bsm.wwg.support, ca-store.wwg.support)
// have no `dev` label and correctly return false.
export default function isDevEnvironment() {
  if (typeof window === "undefined" || !window.location) return false;
  const host = String(window.location.hostname || "").toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]") {
    return true;
  }
  // Treat any hostname label that is exactly "dev" or begins with "dev-" as a
  // dev environment (e.g. dev-store.wwg.support, dev-ca-bsm.wwg.support, or a
  // nested store.dev.wwg.support). Production labels like "store"/"bsm" and
  // words like "developer" never match.
  return host
    .split(".")
    .some((label) => label === "dev" || label.startsWith("dev-"));
}
